import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { INITIAL_PRODUCT_LIST_SEARCH_DATA } from '../../../../../store/modules/product/models';

import ProductAllList from '../ProductAllList';
import ProductListSearchBox from '../../../common/ProductListSearchBox';
import { productActions } from '../../../../../store/modules/product';

const ProductListAllWrap = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { searchOption, filterOption, sortOption, pagination, searchData } = useSelector(
    (state) => state.product.productList,
  );

  const setData = (data) => dispatch(productActions.setData(data));
  const getProductAllList = (data) => dispatch(productActions.getProductAllList(data));

  const getList = (data) => {
    getProductAllList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    if (data.searchData) {
      setData({
        path: ['productList', 'searchData'],
        value: data.searchData,
      });
    }

    navigate(location.pathname, {
      replace: true,
      state: {
        searchData,
        searchOption,
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  useEffect(() => {
    getList({
      ...INITIAL_PRODUCT_LIST_SEARCH_DATA,
      isInit: true,
    });
  }, []);

  return (
    <div className="product-all-list-wrap">
      <ProductListSearchBox getList={getList} />

      <ProductAllList getList={getList} />
    </div>
  );
};

export default ProductListAllWrap;
